module.exports = __webpack_public_path__ + "img/369.320225df.jpg";